module.exports = __webpack_public_path__ + "static/7-5511d70c0869ce1035073d62baab34ae.jpg";